import styled from 'styled-components';

export const StyledStartButton = styled.button`
	box-sizing: border-box;
	padding: 13px;
	width: 100%;
	border-radius: 3px;
	border: none;
	color: white;
	background: #000;
	font-family: Pixel, Arial, Helvetica, sans-serif;
	font-size: 0.8rem;
	outline: none;
	cursor: pointer;

	&::-moz-focus-inner {
		border: 0;
	}
`;
